var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModifierBlanc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67847 1V3.42856L6.4642 4.03571L4.6428 2.21428L2.21427 4.64285L4.03567 6.46427L3.42853 7.67855H1V11.3214H3.42853L4.03567 12.5357L2.21427 14.3571L4.6428 16.7857L6.4642 14.9642L7.67847 15.5714V18H11.3213V15.5714L12.5355 14.9642L14.3569 16.7857L16.7855 14.3571L14.9641 12.5357L15.5712 11.3214H17.9997V7.67855H15.5712L14.9641 6.46427L16.7855 4.64285L14.3569 2.21428L12.5355 4.03571L11.3213 3.42856V1H7.67847Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49958 11.9279C10.8408 11.9279 11.9281 10.8406 11.9281 9.49936C11.9281 8.15811 10.8408 7.0708 9.49958 7.0708C8.15834 7.0708 7.07104 8.15811 7.07104 9.49936C7.07104 10.8406 8.15834 11.9279 9.49958 11.9279Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifierBlanc);
export default __webpack_public_path__ + "static/media/modifier_blanc.383251d6eb6b346e1fb88549e036026e.svg";
export { ForwardRef as ReactComponent };